import type { ListFieldsApiResponse } from '~/redux/api/unified-fields/enhancements';
import type { DataField } from '~/types/Field';
import type { Nullable } from '~/types/Nullable';

import { mapUfClientFieldToDataField } from '~/features/x-ray/fields/mapUfClientFieldToDataField';
import { unifiedFields } from '~/services/serviceInstances';

type Request = {
  id: string;
};

export async function getClientFieldById({
  id,
}: Request): Promise<Nullable<DataField>> {
  const response = await unifiedFields.get<ListFieldsApiResponse>(
    '/client_fields',
    {
      params: {
        'filter[active]': true,
        'filter[id]': id,
        'page[limit]': 1,
      },
    },
  );

  const clientField = response.data?.[0];
  return clientField ? mapUfClientFieldToDataField(clientField) : null;
}
